import { Card } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { useParams, useLocation, useNavigate, Routes, Route, Navigate } from "react-router-dom";

import "./RateCardDetail.scss";
// import { ReactComponent as ExportIcon } from "assets/images/icons/TopNavIcons/ExportIcon.svg";
import PillTabs from "components/atoms/PillTabs/PillTabs";
import { useGetRateCardDetails } from "api/queries/rate-card/useGetRateCardDetails";
import usePermissions from "hooks/usePermissions";
import Alert from "components/molecules/Alert/Alert";
import LoadingSkeleton from "components/atoms/LoadingSkeleton/LoadingSkeleton";
import RateCardGeneral from "./components/RateCardGeneral/RateCardGeneral";
import RateCardRates from "./components/RateCardRates/RateCardRates";
import RateCardLanes from "./components/RateCardLanes/RateCardLanes";

function RateCardDetail() {
  const intl = useIntl();
  const { id } = useParams();
  const { pathname } = useLocation();
  const { permissions } = usePermissions();
  const navigate = useNavigate();
  const { data, isLoading } = useGetRateCardDetails(id as string);

  const handleTabChange = (eventKey: string) => {
    navigate(eventKey);
  };

  if (!JSON.parse(permissions || "{}")?.permissions?.admin_settings?.view_rate_card) {
    return <Navigate to="/access-denied" replace />;
  }

  return (
    <Card body className="shadow-none quote-container rate-card-detail">
      <div className="d-flex align-items-center justify-content-between mb-3">
        {isLoading ? <span className="skeleton" /> : <h3>{data?.name || "-"}</h3>}
        {/* <div>
          <ExportIcon style={{ cursor: "pointer" }} />
        </div> */}
      </div>
      <div>
        <PillTabs
          id="quote-statuses"
          activeKey={pathname}
          onSelect={handleTabChange}
          tabItems={[
            {
              eventKey: `/settings/rate-card/${id}/general`,
              title: intl.formatMessage({ id: "settings.rate-cards.general", defaultMessage: "General" }),
            },
            {
              eventKey: `/settings/rate-card/${id}/rates`,
              title: intl.formatMessage({ id: "settings.rate-cards.rates", defaultMessage: "Rates" }),
            },
            {
              eventKey: `/settings/rate-card/${id}/lanes`,
              title: intl.formatMessage({ id: "settings.rate-cards.lanes", defaultMessage: "Lanes" }),
            },
          ]}
        />
      </div>
      {isLoading && (
        <div className="mt-1">
          <LoadingSkeleton rows={3} />
        </div>
      )}
      {!isLoading && data && (
        <div className="mt-4">
          <Routes>
            <Route path="/general" element={<RateCardGeneral />} />
            <Route path="/rates" element={<RateCardRates />} />
            <Route path="/lanes" element={<RateCardLanes />} />
            <Route path="*" element={<Navigate to={`/settings/rate-card/${id}/general`} replace />} />
          </Routes>
        </div>
      )}
      {!isLoading && !data && (
        <div className="mt-3">
          <Alert variant="neutral" iconClass="mr-1">
            <FormattedMessage id="analytics.noData" defaultMessage="No data available" />
          </Alert>
        </div>
      )}
    </Card>
  );
}

export default RateCardDetail;
